import React from 'react';
import PropTypes from 'prop-types';

import './view-more.scss';

const ViewMore = (props) => {
	const { text, onClick } = props;

	return (
		<div className="view-more">
			<button type="button" className="btn btn--primary" onClick={onClick}>
				{text}
			</button>
		</div>
	);
};

ViewMore.defaultProps = {
	onClick: () => {},
};

ViewMore.propTypes = {
	text: PropTypes.string.isRequired,
	onClick: PropTypes.func,
};

export default ViewMore;
